import { createContext, useEffect, useState } from "react";

export const ContextVar = createContext();

// by default date is today's in context and changing to tomorrow's for checkout
export default function Context({ children }) {
  const [isLoading, setIsLoading] = useState(true);

  async function initSite() {
    try {
    } catch (e) {
      alert(`SITE INIT ERROR\n${e.message}`);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    initSite();
  }, []);

  return <ContextVar.Provider value={{ isLoading, setIsLoading }}>{children}</ContextVar.Provider>;
}
